import { DSToggle } from "@components/design-system/molecules";
import React from "react";
import {
  useFormContext,
  useWatch,
  Controller,
} from "react-hook-form";

export function ObjectiveToggles({
  isEditFieldModeActive,
  setIsEditFieldModeActive,
  note,
}) {
  const { control } = useFormContext();
  const shouldUseGenericObjective = useWatch({
    control,
    name: "shouldUseGenericObjective",
  });

  return (
    <div className="flex flex-row items-center justify-end space-x-4 md:space-x-6 mb-2">
      {!shouldUseGenericObjective ? (
        <div
          id="editFieldsToggle"
          className="flex flex-col md:flex-row items-center space-y-1 md:space-x-2"
        >
          <h5 className="text-xs md:text-sm">Edit Fields </h5>
          <DSToggle
            checked={isEditFieldModeActive}
            onChange={(e) =>
              setIsEditFieldModeActive(e.target.checked)
            }
            dataTestId="edit-fields-toggle"
          />{" "}
        </div>
      ) : null}

      {note?.isAutoSoap ? null : (
        <div
          id="useBlankObjectiveToggle"
          className="flex flex-col md:flex-row items-center space-y-1 md:space-x-2"
        >
          <h5 className="text-xs md:text-sm">Use Blank</h5>

          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <DSToggle
                checked={shouldUseGenericObjective}
                onChange={() => onChange(!shouldUseGenericObjective)}
                dataTestId="use-blank-objective-toggle"
              />
            )}
            name="shouldUseGenericObjective"
          />
        </div>
      )}
    </div>
  );
}
